import { determineSelector, getResource, readUrl } from "./api";

// Single-row read of a PR profile's profile-completion score (the `pr_profile_completion_scores`
// PostgREST view — keyed on the profile's id). Mirrors expert_completion_scores.js's `getById`
// shape, PR's profile-keyed sibling.
const getById = async (profileId) => {
  const selector = determineSelector(profileId, { keyId: "id" });
  const url = readUrl("pr_profile_completion_scores", { selector });
  return getResource(url);
};

export default { getById };
